import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 *
 *  跟团游接口列表
 * 
 */
 const tours = {

    /**
     * 线路
     * 
     */

    //线路列表
    toursList(current,size,start){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt/page',{
            condition:{
                productName:null
            },
            current: current,
            size: size,
            start: start
        },true)
    },

    //添加线路
    addTours(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt/save',form,true)
    },

    //编辑跟团
    updateTours(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt/updateById',form,true)
    },

    //删除跟团
    deleteTours(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt/delete',QS.stringify({
            id:id
        }),false)
    },


    /**
     * 跟团行程
     * 
     */

    //跟团行程列表
    toursRouteList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-journey/listByPid',QS.stringify({
            pid:id
        }),false)
    },

    //添加行程
    addToursRoute(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt-journey/save',form,true)
    },

    //编辑行程
    updateToursRoute(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt-journey/updateById',form,true)
    },

    //删除行程
    deleteToursRoute(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-journey/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     *  单天介绍
     */

    //单天列表
    everDayList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-day/listByJid',QS.stringify({
            pid:id
        }),false)
    },

    //添加单天介绍
    addEverDay(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-day/save',form,true)
    },

    //编辑单天介绍
    updateEverDay(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-day/updateById',form,true)
    },

    //删除单天介绍
    deleteEverDay(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-day/delete',QS.stringify({
            id:id
        }),false)
    },


    /**
     *  单天线路
     * 
     */
    //单天线路列表
    everCourseList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-course/listByDid',QS.stringify({
            pid:id
        }),false)
    },
    
    //添加单天线路
    addEverCourse(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt-course/save',form,true)
    },

    //编辑单天线路
    updateEverCourse(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt-course/updateById',form,true)
    },

    //删除线路
    deleteEverCourse(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-course/delete',QS.stringify({
            id:id
        }),false)
    },


    /**
     * 报名须知
     * 
     */

    //报名须知列表
    applyList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-join/listByPid',QS.stringify({
            pid:id
        }),false)
    },

    //添加报名须知
    addApply(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-join/save',form,true)
    },

    //编辑报名须知
    updateApply(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-join/updateById',form,true)
    },

    //删除报名须知
    deleteApply(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-join/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 费用说明
     * 
     */

     //费用说明列表
    priceList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-cost/listByPid',QS.stringify({
            pid:id
        }),false)
    },

    //添加费用说明
    addPrice(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-cost/save',form,true)
    },

    //编辑费用说明
    updatePrice(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-cost/updateById',form,true)
    },

    //删除报名须知
    deletePrice(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-cost/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 收费规则
     * 
     */

    //收费规则列表
    priceInfoList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo_gt_rates/listByPid',QS.stringify({
            pid:id
        }),false) 
    },
    
    //添加收费规则
    addPriceInfo(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo_gt_rates/save',form,true)
    },

    //编辑收费规则
    updatePriceInfo(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo_gt_rates/updateById',form,true)
    },

    //删除收费规则
    deletePriceInfo(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo_gt_rates/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 温馨提示
     */

    //温馨提示列表
    promptList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-prompt/listByPid',QS.stringify({
            pid:id
        }),false) 
    },

    //添加温馨提示
    addPrompt(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-prompt/save',form,true)
    },

    //编辑温馨提示
    updatePrompt(form){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-prompt/updateById',form,true)
    },

    //删除温馨提示
    deletePrompt(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-prompt/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 图片轮播图
     */

    //图片列表
    slideList(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-img/listByPid',QS.stringify({
            pid:id
        }),false) 
    },

    //添加图片
    addSlide(form){
        return axios.postFrom(ipAddress.qi+'/web/v4/qoo-gt-img/save',form)
    },

    //删除图片
    deleteSlide(id){
        return axios.post(ipAddress.qi+'/web/v4/qoo-gt-img/delete',QS.stringify({
            id:id
        }),false)
    }



 }
 export default tours;


// WEBPACK FOOTER //
// ./src/js/toursVip/tours.js